import { ReactNode } from 'react';
import * as Sentry from '@sentry/react';
import { ErrorMessage } from './ErrorMessage/ErrorMessage';

export const ErrorBoundary = ({ children }: { children: ReactNode }): JSX.Element => (
	<Sentry.ErrorBoundary
		fallback={<ErrorMessage />}
		beforeCapture={(scope, _error, componentStack) => {
			scope.setTag('error_boundary', 'global');
			scope.setContext('react_error_boundary', {
				componentStack,
				pathname: window.location.pathname,
				search: window.location.search,
				hash: window.location.hash,
			});
		}}
	>
		{children ?? null}
	</Sentry.ErrorBoundary>
);
